import { render, staticRenderFns } from "./TicketTransferModal.vue?vue&type=template&id=22069b60"
import script from "./TicketTransferModal.vue?vue&type=script&lang=js"
export * from "./TicketTransferModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports